import { Box, Tab, Tabs, useTheme } from '@mui/material'
import * as React from 'react'
import { useState } from 'react'
import CodeBlock from './CodeBlock'
import Multiply from '../Multiply.txt'
import { overrideTabColour } from './SharedFns'

export function CalculationExamples() {
  const theme = useTheme()
  const [value, setValue] = useState(0)
  return (
    <Box sx={{ display: 'flex', width: 1, mt: 1, minHeight: 200 }}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={(_, newVal) => setValue(newVal)}
        sx={overrideTabColour(theme)}
      >
        <Tab
          label="Multiply"
          sx={{ color: theme.palette.info + '!important' }}
        />
      </Tabs>
      {value === 0 && <CodeBlock file={Multiply} />}
    </Box>
  )
}

export default CalculationExamples
